// src/components/About/MissionVision.tsx
import React from 'react';
import { FaUsers } from 'react-icons/fa';
import {

  MissionVisionWrapper,
  MissionVisionCard,

} from './ MissionVision.styles';

import { SectionContentWrapper, GlassContainer, WhiteCard } from '../About.styles';

const MissionVision: React.FC = () => {
  return (
    <GlassContainer>
      <WhiteCard>
        <SectionContentWrapper>
          <h2>
            <FaUsers style={{ marginRight: '0.5rem', color: '#039BE5' }} />
            Mission & Vision
          </h2>
          <p>
            Our mission and vision define our commitment to making a meaningful impact in the lives of
            individuals and communities. They reflect our dedication to compassionate care and a shared
            journey toward a brighter, more inclusive future.
          </p>
          <MissionVisionWrapper>
            <MissionVisionCard>
              <h3>Our Mission</h3>
              <p>
                To end health-related suffering through compassionate care, delivering palliative and hospice
                services that respect the whole person—body, mind, and spirit.
              </p>
              <p>
                Our mission focuses on providing equitable care, addressing the needs of underserved communities,
                and advocating for health justice worldwide.
              </p>
            </MissionVisionCard>
            <MissionVisionCard>
              <h3>Our Vision</h3>
              <p>
                By illuminating paths of understanding, we envision communities worldwide that embrace holistic
                well-being, informed support, and a collective commitment to uplifting one another.
              </p>
              <p>
                We strive for a future where compassion drives action, ensuring dignity and hope for every life
                touched by our efforts.
              </p>
            </MissionVisionCard>
          </MissionVisionWrapper>
        </SectionContentWrapper>
      </WhiteCard>
    </GlassContainer>
  );
};

export default MissionVision;
